import { VisitStatusTimelineFragment } from "./fragment.generated";

export const STATUS_TO_TRANSLATION_KEY_MAP: Record<VisitStatusTimelineFragment["plannerStatus"], string> = {
    impossible: "visitStatusTimeline.impossible",
    notYetPlannable: "visitStatusTimeline.notYetPlannable",
    outOfProtocol: "visitStatusTimeline.outOfProtocol",
    plannableAtRisk: "visitStatusTimeline.plannableAtRisk",
    plannableOk: "visitStatusTimeline.plannableOk",
    plannableSoon: "visitStatusTimeline.plannableSoon",
    planned: "visitStatusTimeline.planned",
};
